/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_LabelInputs */

const en_privacy_label = /** @type {(inputs: Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

const lv_privacy_label = /** @type {(inputs: Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridiskā informācija`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Privacy_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_label = /** @type {((inputs?: Privacy_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_label(inputs)
	return en_privacy_label(inputs)
});